// ── DESIGN TOKENS ──────────────────────────────────────────
export const C = {
  g900:'#0D2218', g800:'#1A3A28', g700:'#235233', g600:'#2D6B42',
  g500:'#3D8A57', g400:'#5AAE73', g300:'#85C99A', g100:'#E8F5EE', g50:'#F2FAF5',
  white:'#FFFFFF', text:'#1A2820', muted:'#5A7065', border:'#C8DDD2',
  error:'#C0392B',
  // Shared header/banner gradient — deep emerald, used app-wide.
  // Use this for page headers and card title bars so every page matches.
  headerGrad:'linear-gradient(150deg,#0F3D24 0%,#1E6B3C 60%,#2E8B4F 100%)',
}

export const GCSS = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:wght@300;400;500;600&display=swap');
  *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
  html{scroll-behavior:smooth}
  body{font-family:'DM Sans',sans-serif;background:#fff;color:#1A2820;-webkit-font-smoothing:antialiased;overflow-x:hidden}
  h1,h2,h3,h4,h5{font-family:'DM Serif Display',serif;font-weight:400}
  ::selection{background:#85C99A;color:#0D2218}
  ::-webkit-scrollbar{width:4px}
  ::-webkit-scrollbar-track{background:#F2FAF5}
  ::-webkit-scrollbar-thumb{background:#5AAE73;border-radius:2px}
  @keyframes fadeUp{from{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}
  @keyframes fadeIn{from{opacity:0}to{opacity:1}}
  @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-12px)}}
  @keyframes marquee{from{transform:translateX(0)}to{transform:translateX(-50%)}}
  @keyframes pulse{0%,100%{opacity:1}50%{opacity:.45}}
  .f1{animation:fadeUp .8s ease both}
  .f2{animation:fadeUp .8s .12s ease both}
  .f3{animation:fadeUp .8s .24s ease both}
  .f4{animation:fadeUp .8s .38s ease both}
  .float-anim{animation:float 6s ease-in-out infinite}
  .brand-card{transition:all 0.18s ease;cursor:pointer;}
  .brand-card:hover{transform:translateY(-3px);box-shadow:0 8px 24px rgba(0,0,0,0.1)!important;}
  .brand-letter-btn{transition:all 0.15s;}
  .brand-letter-btn:hover{background:#235233!important;color:white!important;}
`

export const s = {
  btnPrimary:{background:C.g700,color:'white',padding:'.55rem 1.4rem',borderRadius:8,fontSize:'.82rem',fontWeight:600,border:'none',cursor:'pointer',fontFamily:"'DM Sans',sans-serif",letterSpacing:'.03em',boxShadow:`0 2px 8px rgba(35,82,51,.25)`,transition:'all .2s',textDecoration:'none',display:'inline-flex',alignItems:'center',gap:7},
  btnOutline:{background:'white',border:`1px solid ${C.border}`,color:C.text,padding:'.5rem 1.1rem',borderRadius:8,fontSize:'.8rem',fontWeight:500,cursor:'pointer',fontFamily:"'DM Sans',sans-serif",transition:'all .2s'},
  btnGreen:{background:C.g400,color:C.g900,padding:'.85rem 2rem',borderRadius:10,fontSize:'.875rem',fontWeight:600,border:'none',cursor:'pointer',fontFamily:"'DM Sans',sans-serif",letterSpacing:'.04em',boxShadow:`0 4px 20px rgba(90,174,115,.35)`,transition:'all .2s',textDecoration:'none',display:'inline-flex',alignItems:'center',gap:8},
  btnGhost:{background:'rgba(255,255,255,.1)',color:'white',padding:'.85rem 2rem',borderRadius:10,fontSize:'.875rem',fontWeight:500,border:'1px solid rgba(255,255,255,.2)',cursor:'pointer',fontFamily:"'DM Sans',sans-serif",letterSpacing:'.04em',transition:'all .2s',textDecoration:'none',display:'inline-flex',alignItems:'center',gap:8},
  tag:{display:'inline-flex',alignItems:'center',gap:8,background:'rgba(255,255,255,.08)',border:'1px solid rgba(255,255,255,.15)',borderRadius:999,padding:'.35rem 1rem',marginBottom:'1.75rem'},
  eyebrow:{fontSize:'.68rem',letterSpacing:'.18em',textTransform:'uppercase',color:C.g600,marginBottom:'.65rem',display:'flex',alignItems:'center',gap:10},
  sectionTitle:{fontFamily:"'DM Serif Display',serif",fontSize:'clamp(1.8rem,3.5vw,2.75rem)',color:C.g900,lineHeight:1.15},
  inner:{maxWidth:1600,margin:'0 auto',padding:'0 2rem'},
}
